import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/htx/current-cardiological-state/spect";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	spect: {
		id: "form.spect",
		defaultMessage: "SPECT"
	},
	description: {
		id: "form.spect.description",
		defaultMessage: "Szöveges összefoglaló"
	}
});

const fields: { [key: string]: FieldData } = {
	description: {
		type: "field",
		path: ["description"],
		label: messages.description,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.description }] }]
};

export const node: LeafNode = {
	id: "spect",
	value: {
		title: messages.spect,
		validator,
		fieldset
	}
};
